import { io } from "socket.io-client";
import { Api_URI } from "../Api";

let socketInstance = null;
let currentToken = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;

export function getSocketClient(token) {
    if (socketInstance && currentToken !== token) {
        socketInstance.disconnect();
        socketInstance = null;
        currentToken = null;
    }

    if (!socketInstance || !socketInstance.connected) {
        if (!token) {
            console.warn("No token provided for socket connection");
            return null;
        }

        socketInstance = io(Api_URI, {
            auth: {
                token: token,
            },
            query: {
                token: token,
            },
            transports: ["websocket", "polling"],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
        });

        currentToken = token;

        socketInstance.on("connect", () => {
            console.log("Socket connected:", socketInstance.id);
            reconnectAttempts = 0;
        });

        socketInstance.on("disconnect", (reason) => {
            console.log("Socket disconnected:", reason);
            if (reason === "io server disconnect") {
                socketInstance.connect();
            }
        });

        socketInstance.on("connect_error", (error) => {
            console.error("Socket connection error:", error);
            reconnectAttempts++;
            if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
                console.error("Max reconnection attempts reached");
            }
        });

        socketInstance.on("reconnect", (attemptNumber) => {
            console.log("Socket reconnected after", attemptNumber, "attempts");
            reconnectAttempts = 0;
        });

        socketInstance.on("reconnect_attempt", (attemptNumber) => {
            console.log("Socket reconnection attempt:", attemptNumber);
        });

        socketInstance.on("reconnect_failed", () => {
            console.error("Socket reconnection failed");
        });
    }

    return socketInstance;
}

export function disconnectSocket() {
    if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
        currentToken = null;
    }
}

export function isSocketConnected() {
    return socketInstance && socketInstance.connected;
}

export function getCurrentSocket() {
    return socketInstance;
}